import { useMemo } from 'react'
import { HeaderContext } from '@tanstack/react-table'
import clsx from 'clsx'

import { Log } from '@/types/logs'
import { Button } from '@/ui/Button'
import styles from './DeadlineHeader.module.scss'

import ArrowDownIcon from '../../../assets/arrow-down.svg'

export const DeadlineHeader = ({ table, column }: HeaderContext<Log, unknown>) => {
    const state = table.getState()

    const isActive = useMemo(() => state.sorting.find((item) => item.id === column.id), [state, column.id])

    const handleSortColumn = () => {
        column.toggleSorting(false)
    }

    return (
        <Button
            size="small"
            variant="transparent"
            onClick={handleSortColumn}
            className={clsx(styles.trigger, { [styles.active]: isActive })}
        >
            <span>Deadline</span>
            <ArrowDownIcon />
        </Button>
    )
}
